export const SM_SET_UI_FLAG = 'SM_SET_UI_FLAG';
export const SM_SET_SUMMARY = 'SM_SET_SUMMARY';
export const SM_SET_SENTIMENT = 'SM_SET_SENTIMENT';
export const SM_SET_ENGAGEMENT = 'SM_SET_ENGAGEMENT';
export const SM_SET_COMPETITORS = 'SM_SET_COMPETITORS';
export const SM_SET_TOP_MENTIONERS = 'SM_SET_TOP_MENTIONERS';
export const SM_SET_MENTIONS = 'SM_SET_MENTIONS';
export const SM_SET_PROFILES = 'SM_SET_PROFILES';
export const SM_ADD_PROFILE = 'SM_ADD_PROFILE';
export const SM_UPDATE_PROFILE = 'SM_UPDATE_PROFILE';
export const SM_REMOVE_PROFILE = 'SM_REMOVE_PROFILE';
export const SM_SET_SETTINGS = 'SM_SET_SETTINGS';
export const SM_SET_POLITICAL_INSIGHTS = 'SM_SET_POLITICAL_INSIGHTS';
export const SM_SET_PUBLIC_REACTION = 'SM_SET_PUBLIC_REACTION';
export const SM_SET_PUBLIC_REACTION_ANALYSIS =
  'SM_SET_PUBLIC_REACTION_ANALYSIS';
export const SM_SET_TOPICS = 'SM_SET_TOPICS';
export const SM_SET_REPORTS = 'SM_SET_REPORTS';
export const SM_SET_CURRENT_REPORT = 'SM_SET_CURRENT_REPORT';
export const SM_SET_CLUSTERS = 'SM_SET_CLUSTERS';
export const SM_SET_ALERTS = 'SM_SET_ALERTS';
export const SM_SET_ALERT_UNREAD = 'SM_SET_ALERT_UNREAD';
export const SM_MARK_ALERT_ACK = 'SM_MARK_ALERT_ACK';
export const SM_SET_CONTENT_BREAKDOWN = 'SM_SET_CONTENT_BREAKDOWN';
export const SM_SET_CONVERSION_INDICES = 'SM_SET_CONVERSION_INDICES';
export const SM_SET_NARRATIVES = 'SM_SET_NARRATIVES';
export const SM_SET_EMOTION_BREAKDOWN = 'SM_SET_EMOTION_BREAKDOWN';
export const SM_SET_CONTENT_SUGGESTIONS = 'SM_SET_CONTENT_SUGGESTIONS';
export const SM_SET_RESPONSE_LIBRARY = 'SM_SET_RESPONSE_LIBRARY';
export const SM_SET_COPILOT = 'SM_SET_COPILOT';
export const SM_SET_TERRITORIAL_BREAKDOWN = 'SM_SET_TERRITORIAL_BREAKDOWN';
export const SM_SET_DEMOGRAPHIC_BREAKDOWN = 'SM_SET_DEMOGRAPHIC_BREAKDOWN';
export const SM_SET_TERRITORIAL_SEGMENTATION =
  'SM_SET_TERRITORIAL_SEGMENTATION';
